<h2 mat-dialog-title>Export documentation</h2>
<mat-dialog-content>
  <div class="entity-form">
    <mat-form-field>
      <mat-label>Prepared By</mat-label>
      <input matInput [formField]="form.preparedBy" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Email</mat-label>
      <input matInput type="email" [formField]="form.userEmail" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Phone</mat-label>
      <input matInput type="tel" [formField]="form.userPhone" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Version</mat-label>
      <input matInput [formField]="form.version" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Recipient</mat-label>
      <input matInput type="email" [formField]="form.recipient" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>JQL Expression</mat-label>
      <input matInput [formField]="form.jqlExpression" />
      <mat-hint>e.g. issueKey in (ARTMXCICH-159, ARTMXCICH-158)</mat-hint>
    </mat-form-field>

    <mat-checkbox [formField]="form.addDraftWatermark">Add draft watermark</mat-checkbox>

    <mat-checkbox [formField]="form.includeComments">Include comments</mat-checkbox>

    <mat-checkbox [formField]="form.includeImages">Include images</mat-checkbox>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matMiniFab (click)="save()" [disabled]="!form().valid() || pending()">
    <mat-icon>send</mat-icon>
  </button>
</mat-dialog-actions>
@if (pending()) {
  <mat-progress-bar mode="indeterminate" />
}
